<script>
  // import { onMount } from 'svelte';

  import { isMobile } from '../../stores/IsMobile.js';
  import { cartDetails } from '../../stores/Cart.js';

  import DropdownMenu from './DropdownMenu.svelte';
  //   import MegaMenu from "./MegaMenu.svelte";
  //   import SearchBar from "../SearchBar.svelte";
  //   import {
  //     design,
  //     events,
  //     sports,
  //     sportsSimple,
  //     workwear,
  //   } from "../../utils/menulinks.js";

  import MobileNav from './MobileNav.svelte';
  import CartDropdown from '../Cart/CartDropdown.svelte';

  export let segment;
  export let productCategories;
  export let sportsCollections;
  export let workCollections;
  export let eventCollections;
  export let schoolCollections;

  // let showCountryList = false;
  let showMobileNav = false;
  let showCart = false;

  // const countries = [
  //   { img: 'us.svg', name: 'USA' },
  //   { img: 'au.svg', name: 'Australia' },
  //   { img: 'gb.svg', name: 'UK' },
  //   { img: 'ru.svg', name: 'Russia' },
  // ];

  let logo = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 208 43.4" enable-background="new 0 0 208 43.4" xml:space="preserve">
<g>
	<path fill-rule="evenodd" clip-rule="evenodd" fill="#F15B22" d="M12.7,16.7v14.9h-2.5V16.7H4v17.4c0,1.4,1,2.5,2.5,2.5h12.4V16.7
		H12.7L12.7,16.7z M30.6,25.9l-2.9-9.2h-6.6v19.8h5.7v-2.5L26,27.4h0.5l2.9,9.1H36V16.7h-5.7v2.5l0.8,6.7H30.6L30.6,25.9z
		 M44.4,36.5V16.7h-6.2v19.8H44.4L44.4,36.5z M52.9,29.9H59v-5h-6.1v-3.2H59l1-2.5v-2.5H46.7v19.8h6.2V29.9L52.9,29.9z M70,21.7v9.9
		h-2.5v-9.9H70L70,21.7z M73.8,36.5c1.5,0,2.5-1,2.5-2.5V19.2c0-1.4-1-2.5-2.5-2.5h-9.9c-1.5,0-2.5,1-2.5,2.5v14.9
		c0,1.4,1,2.5,2.5,2.5H73.8L73.8,36.5z M87.2,21.7v3.7h-2.5v-3.7H87.2L87.2,21.7z M78.5,16.7v19.8h6.2v-6.2H86l1.7,6.2h6.1v-2.5
		l-2-4.9c0.9-0.3,1.6-1.3,1.6-2.2v-7.8c0-1.4-1-2.5-2.5-2.5H78.5L78.5,16.7z M102.9,36.5h5.2l1.5-9.5h0.5v9.5h6v-2.5l-2-17.4h-6.9
		l-1.5,7.8h-0.4l-1.5-7.8h-6.9l-2,17.4v2.5h6.1V27h0.5L102.9,36.5z"/>
	<path fill-rule="evenodd" clip-rule="evenodd" fill="#202B5B" d="M128.7,23.9v-7.2h-6.2v19.8h6.2v-7.7h2.5v7.7h6.2V16.7h-6.2v7.2
		H128.7L128.7,23.9z M152.9,36.5v-5h-7.1v-2.7h6.1v-5h-6.1v-2.2h6.1l1-2.5v-2.5h-13.3v19.8H152.9L152.9,36.5z M163.3,21.7v3.7h-2.5
		v-3.7H163.3L163.3,21.7z M154.6,16.7v19.8h6.2v-6.2h1.2l1.7,6.2h6.1v-2.5l-2-4.9c0.9-0.3,1.6-1.3,1.6-2.2v-7.8c0-1.4-1-2.5-2.5-2.5
		H154.6L154.6,16.7z M180.2,21.7v9.9h-2.5v-9.9H180.2L180.2,21.7z M183.9,36.5c1.5,0,2.5-1,2.5-2.5V19.2c0-1.4-1-2.5-2.5-2.5H174
		c-1.5,0-2.5,1-2.5,2.5v14.9c0,1.4,1,2.5,2.5,2.5H183.9z"/>
	<g>
		<path fill-rule="evenodd" clip-rule="evenodd" fill="#202B5B" d="M201.3,21.5c0-1,0.6-0.6-0.2-1.5c-0.3,6-0.5,3.4-1.1,6.5
			c-0.4,2.2-0.9,4.3-0.9,6.7c0,6.2,2.8,4.4,3.6,6.1h-5.3c-0.9-0.2-0.7-0.4-0.6-1.2c0.1-0.9,0.4-2.2,0.3-3c-0.1-1.1-0.8-2.3-0.9-3.4
			c-0.2-1.6,0.3-2.4,0.7-3.7c0.3-1.2-0.2-2.7,0-4.3c-0.2,0.2-0.1,0.1-0.3,0.3l-0.9,1.2c-0.5,0.8-0.6,1.1-0.9,1.9
			c-1.2,3.2-0.8,3.1-1.2,4.2c-0.6,1.5-2.5,4.1-2.5,5.8c0,1.1,0.7,1.5,0.3,2.1c-0.1,0-0.1,0-0.2,0h-2.9c-0.2,0-0.5,0.1-0.6,0
			c0.3-0.8,0.7-0.6,1-1.8c0.3-1,0.6-1.2,0.8-2c0.4-1.3,0.3-3.3,0.8-4.9c0.5-1.7,1.1-2.4,1.7-4c0.5-1.5,0.8-2.9,1.2-4.5
			c-1.3,0.3-1.9,0.8-2.2-1c-0.2-1.3-0.2-2-0.9-2.8c-1.6,0.6-4.7,4.4-7.4,0c-4.3-7-3.3-4.2-5.1-6.4c2.2-0.2,5,0.1,6.8-0.9
			c1.5-0.9,2.7-3,5.4-2.5c1.6,0.3,4.7,2.1,5.7,0.1c0.6-1.2,0.1-0.9,0.1-2c0-1.1-0.1-1.8,0.4-2.2c0.2-0.1,1.3-0.5,1.6-0.5
			c1.4,0,1.2,2,1.2,2c0.4,2.5-1.3,1.6-0.2,3.2c1.2,1.7,4.4,0.6,3.1,4c-0.1,0.3-0.4,3-0.4,3.1c0.1,0.3,0.4,0.8,0.6,1.3
			c0.2,0.6,0.2,1.1,0.5,1.6c0.5,0.9,1.8,1.3,1.4,2.2C203.5,22.6,202,21.9,201.3,21.5L201.3,21.5z M194.6,18.9
			c-0.6-0.3-1.4-0.5-2.1-0.7c-0.7,1.9,0.2,1.8,1,2.5c0.3,0.3-0.1,0,0.3,0.3C193.9,20.1,194.3,19.8,194.6,18.9z"/>
	</g>
</g>
</svg>`;

  let bagIcon = `<svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.4581 15L12.8311 14.1478L12.3544 3.03159H9.16121C8.77442 1.2422 7.78697 0 6.6035 0C5.41881 0 4.4342 1.2422 4.04578 3.03159H0.941689L0.169312 14.3856L0.667894 15.0004H12.4581V15ZM8.26895 4.73552C8.26895 5.03119 8.50751 5.27015 8.80196 5.27015C9.09762 5.27015 9.33699 5.03119 9.33699 4.73552C9.33699 4.65006 9.33537 4.56379 9.33375 4.47914C9.52573 4.63264 9.64886 4.86756 9.64886 5.13082C9.64886 5.59133 9.27624 5.96395 8.81654 5.96395C8.35643 5.96395 7.98381 5.59133 7.98381 5.13082C7.98381 4.88497 8.09276 4.66343 8.26247 4.51154C8.26652 4.58526 8.26895 4.66059 8.26895 4.73552ZM6.6035 1.07007C7.16121 1.07007 7.76267 1.82463 8.06684 3.032H5.13934C5.44473 1.82544 6.04659 1.07007 6.6035 1.07007ZM3.87284 4.50587C3.87041 4.58202 3.86919 4.65897 3.86919 4.73552C3.86919 5.03119 4.10937 5.27015 4.40423 5.27015C4.69989 5.27015 4.93885 5.03119 4.93885 4.73552C4.93885 4.65168 4.94129 4.56865 4.94372 4.48562C5.13124 4.63872 5.25153 4.8712 5.25153 5.13163C5.25153 5.59174 4.87891 5.96436 4.4184 5.96436C3.9587 5.96436 3.58689 5.59174 3.58689 5.13163C3.58811 4.88214 3.69827 4.65776 3.87284 4.50587Z" fill="currentColor"/>
</svg>`;

  let phoneIcon = `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" d="M31.44,24.56l-3.93-2.12c-0.96-0.52-1.7-0.14-2.53,0.99c-1.81,2.49-2.69,2.98-4.91,1.74
	c-2.07-1.16-3.56-2.53-5.42-4.39c-1.86-1.86-3.24-3.34-4.39-5.42c-1.24-2.22-0.75-3.1,1.74-4.91c1.13-0.82,1.51-1.57,0.99-2.53
	L10.88,4c-0.87-1.67-2.09-1.86-3.91-1.25c-2.5,0.85-4.93,4.47-4.8,6.18c0.36,5.02,2.87,11.04,8.1,16.27s11.25,7.74,16.27,8.1
	c1.72,0.12,5.31-2.32,6.16-4.83C33.3,26.65,33.11,25.42,31.44,24.56z"/>
<path fill="currentColor" d="M19.68,9.42c-0.83,0.01-1.49,0.68-1.49,1.51c0.01,0.82,0.68,1.49,1.5,1.49c0.01,0,0.03,0,0.04,0
	c0.89,0,1.73,0.34,2.36,0.97c0.63,0.63,0.98,1.48,0.97,2.38c-0.01,0.83,0.66,1.51,1.49,1.51h0.01c0.82,0,1.49-0.66,1.5-1.49
	c0.01-1.71-0.64-3.32-1.85-4.53C23,10.07,21.37,9.43,19.68,9.42z M28.63,6.85c-2.39-2.39-5.61-3.7-8.95-3.69
	c-0.83,0-1.5,0.68-1.49,1.51c0,0.83,0.67,1.49,1.5,1.49c0.01,0,0.03,0,0.04,0c2.56,0,4.97,1,6.78,2.81
	c1.82,1.82,2.82,4.24,2.81,6.82c0,0.83,0.67,1.5,1.49,1.51h0.01c0.83,0,1.5-0.67,1.5-1.49C32.33,12.42,31.02,9.24,28.63,6.85z"/>
</svg>
`;

  function toggleMobileNav() {
    if (window.matchMedia('(min-width: 800px)').matches) {
      showMobileNav = !showMobileNav;
    } else {
      showMobileNav = true;
    }
  }

  // onMount(() => {
  //   LiveChatWidget.call('maximize');
  // });
</script>

<nav class="nav">
  {#if $isMobile}
    <div class="nav__left">
      <div class="nav__button">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <img src="img/icons/nav-burger.svg" alt="" on:click={toggleMobileNav} />
      </div>

      <div class="nav__logo_mobile">
        <a href="/">
          <img src="https://images.uniformhero.com.au/assets/logo.jpg" class="logo" alt="" width="100px" /></a
        >
      </div>
    </div>

    <div class="nav__right">
      <div class="nav__phone">
        <a href="tel:1300011270"
          ><span class="phone-icon"> {@html phoneIcon}</span>
          <span class="phone-number">1300 011 270</span>
        </a>
      </div>
      <!-- Don't show mini cart on cart page -->
      {#if segment !== 'cart'}
        <CartDropdown bind:show={showCart} />
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="nav__cart" on:click={() => (showCart = !showCart)}>
          <span>{@html bagIcon}</span>
          <span>Cart</span>
          <span class="products">{$cartDetails?.items?.length ? $cartDetails?.items?.length : 0}</span>
        </div>
      {/if}
    </div>
    <MobileNav
      bind:show={showMobileNav}
      {productCategories}
      {sportsCollections}
      {schoolCollections}
      {workCollections}
      {eventCollections}
    />
  {:else}
    <div class="nav__left">
      <div class="nav__logo">
        <a href="/">{@html logo}</a>
      </div>

      <!-- <div class="search">
      <SearchBar />
    </div> -->
      <ul class="nav__links">
        <!-- <li class="nav__link-item">
        <a class:active={segment === 'products'} href="products">Products</a>
      </li> -->
        <li class="nav__link-item">
          <a class:active={segment === 'products'} href="products" target="_self">Products</a>
          <div class="menu">
            <DropdownMenu category={'products'} items={productCategories} />
          </div>
        </li>
        <li class="nav__link-item">
          <a class:active={segment === 'sports'} href="/sports" target="_self">Sports</a>
          <div class="menu">
            <DropdownMenu category={'sports'} items={sportsCollections} />
          </div>
        </li>
        <li class="nav__link-item">
          <a class:active={segment === 'work'} href="/work" target="_self">Work</a>
          <div class="menu">
            <DropdownMenu category={'work'} items={workCollections} />
          </div>
        </li>
        <li class="nav__link-item">
          <a class:active={segment === 'school'} href="/school" target="_self">School</a>
          <div class="menu">
            <DropdownMenu category={'school'} items={schoolCollections} />
          </div>
        </li>
        <li class="nav__link-item">
          <a class:active={segment === 'events'} href="/events" target="_self">Events</a>
          <div class="menu">
            <DropdownMenu category={'events'} items={eventCollections} />
          </div>
        </li>
        <li class="nav__link-item">
          <a class:active={segment === 'faqs'} href="faqs">FAQ </a>
        </li>
        <li class="nav__link-item">
          <a class:active={segment === 'contact'} href="contact">Contact Us </a>
        </li>
        <!-- <li class="nav__link-item">
        <a class:active={segment === "blog"} href="blog">Blog </a>
      </li> -->

        <!-- <li class="nav__link-item">
        <a class:active={segment === "workwear"} href="workwear">workwear</a>
        <div class="menu">
          <MegaMenu item={workwear} />
        </div>
      </li>
      <li class="nav__link-item">
        <a class:active={segment === "events"} href="about">events</a>
        <div class="menu">
          <MegaMenu item={events} />
        </div>
      </li>
      <li class="nav__link-item">
        <a class:active={segment === "design"} href="design">design your own</a>
        <div class="menu">
          <MegaMenu item={design} />
        </div>
      </li> -->
      </ul>
    </div>
    <div class="nav__right">
      <div class="nav__phone">
        <a href="tel:1300011270"
          ><span class="phone-icon"> {@html phoneIcon}</span>
          <span class="phone-number">1300 011 270</span>
        </a>
      </div>
      <!-- Don't show mini cart on cart page -->
      {#if segment !== 'cart'}
        <CartDropdown bind:show={showCart} />
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="nav__cart" on:click={() => (showCart = !showCart)}>
          <span>{@html bagIcon}</span>
          <span>Cart</span>
          <span class="products">{$cartDetails?.items?.length ? $cartDetails?.items?.length : 0}</span>
        </div>
      {/if}
      <!-- <div class="nav__auth">
      {#if !$isLoading}
        {#if $isAuthenticated}
          <div class="">
            <a href="/account"
              ><img class="user_icon" src="img/icons/user.svg" alt="" /><span
                >{$userInfo.given_name
                  ? $userInfo.given_name
                  : "Acccount"}</span
              ></a
            >
          </div>
        {:else}
          <div class=""><a on:click={() => login()} href={""}>Login</a></div>
        {/if}
      {/if}
    </div> -->
      <!-- <div
			class="nav__country"
			on:click={() => (showCountryList = !showCountryList)}>
			<span>Country :</span>
			<span>USA</span>
			<img src="img/icons/triangle.svg" alt="" />
			<Dropdown bind:show={showCountryList}>
				{#each countries as country}
					<div class="country"><img src="img/flag/{country.img}" alt=""> {country.name}</div>
				{/each}
			</Dropdown>
		</div>
        -->
    </div>
  {/if}
</nav>

<style>
  a {
    color: #1c2a5c;
    text-decoration: none;
    letter-spacing: 0.5px;
    font-size: 1.4rem;
  }

  .nav {
    color: #1c2a5c;
    border-bottom: 1px solid #1c2a5c;
    text-transform: uppercase;
    font-family: 'Oswald', sans-serif;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 10;
    padding: 1rem 2rem;
  }

  .nav__left {
    display: flex;
    align-items: center;
  }

  .nav__logo {
    width: 150px;
  }

  .nav__logo_mobile {
    margin-left: 2rem;
  }

  .nav__links {
    display: flex;
    margin-left: 8rem;
    list-style: none;
  }

  .nav__links li:not(:first-child) {
    margin-left: 3rem;
  }

  .nav__links a {
    position: relative;
  }

  .nav__links a.active:before,
  .nav__links a:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -5px;
    left: 0;
    background: #fe5900;
    visibility: visible;
  }

  .nav__links a.active:before {
    transform: scaleX(1);
  }

  .nav__links a:before {
    transform: scaleX(0);
    transition: 0.2s ease;
  }
  .nav__links a:hover:before {
    visibility: visible;
    transform: scaleX(1);
  }

  .nav__link-item .menu {
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 0.3s,
      opacity 0.3s ease;
    transition-delay: 0.2s;
    position: relative;
  }

  .nav__link-item:hover .menu {
    visibility: visible;
    opacity: 1;
  }

  .nav__right {
    display: flex;
    align-items: center;
    position: relative;
    gap: 2rem;
  }

  .nav__phone a {
    display: flex;
    align-items: center;
  }

  .phone-icon {
    display: none;
    align-items: center;
    scale: 0.7;
  }

  .phone-number {
    display: none;
  }

  .nav__cart {
    cursor: pointer;
    background-color: #fe5900;
    padding: 1rem 0.2rem;
    color: whitesmoke;
  }

  .nav__cart > *:not(:last-child) {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }

  .nav__cart .products {
    padding: 0.2rem 1rem;
    border-left: 1px solid whitesmoke;
  }

  .nav__auth {
    display: none;
  }

  .nav__auth > *:first-child {
    margin-right: 2rem;
    padding-right: 2rem;
    cursor: pointer;
  }

  .user_icon {
    margin-right: 4px;
  }

  .nav__country {
    display: none;
    align-items: center;
    font-family: 'inter', sans-serif;
    font-weight: 600;
    letter-spacing: 2px;
    cursor: pointer;
    position: relative;
  }

  .nav__country > span:first-child {
    color: #888;
  }

  .nav__country > span {
    margin-right: 0.5rem;
  }

  .country {
    font-size: 1.3rem;
    display: flex;
    align-items: center;
  }

  .country img {
    margin-right: 1rem;
    width: 3rem;
  }

  .nav__button {
    min-height: 35px;
    background-color: #1c2a5c;
    align-self: stretch;
    display: flex;
    align-items: center;
    padding: 0 1.5rem;
    cursor: pointer;
    user-select: none;
  }

  .mobile-icon {
    display: flex;
    align-items: center;
    margin-left: 1rem;
    margin-right: 2rem;
  }

  .bag-icon {
    display: none;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    margin-left: 2rem;
    margin-right: 1rem;
  }

  .search {
    display: none;
  }

  .hidden {
    display: none;
  }

  @media screen and (min-width: 350px) {
    .bag-icon {
      display: inline-block;
    }

    .mobile-icon {
      margin-left: 2rem;
    }
  }

  @media screen and (min-width: 360px) {
    .nav__cart {
      padding: 1rem 1rem;
    }
  }

  @media screen and (min-width: 400px) {
    .phone-icon {
      display: flex;
    }
  }

  @media screen and (min-width: 550px) {
    .search {
      width: 50rem;
      margin-right: 2rem;
      display: inline-block;
    }
    .nav__logo {
      width: 200px;
    }
  }

  @media screen and (min-width: 600px) {
    .nav__auth {
      display: flex;
    }
  }

  @media screen and (min-width: 786px) {
    .nav__country {
      display: flex;
    }
  }

  @media screen and (min-width: 860px) {
    .phone-number {
      display: block;
    }
  }

  @media screen and (min-width: 1400px) {
    a {
      font-size: 1.6rem;
    }
  }

  @media print {
    .nav {
      display: none;
    }
  }
</style>
